export const isAppSource = (): boolean => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('source') === 'app';
};
